// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-author{margin-left:auto;margin-right:auto;display:flex;max-width:56rem;flex-direction:column;align-items:center;justify-content:center}@media (min-width: 768px){.card-author{flex-direction:row;align-items:flex-start}}@media screen and (max-width:768px){.card-author{align-items:stretch;padding:1rem}.card-author img{width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
